import classNames from 'classnames';
import PropTypes from 'prop-types';
import { _ } from '/@/locale';
import styles from './styles.module.css';

const getLabel = (type) => {
    if (type === 'drift') return _('Deriva');
    if (type === 'evaporation') return _('Evaporación');
    if (type === 'wash') return _('Lavado');
};

export const getSuggestion = (risk) => {
    const counter = { R: 0, Y: 0, G: 0 };
    Object.values(risk).map((risk) => (counter[risk] += 1));

    //Logica de aplicación
    if (counter['R'] > 0) return { color: 'R', label: _('No aplicar') };
    if (counter['G'] === 3) return { color: 'G', label: _('Apto aplicación') };
    if (counter['G'] > 0 && counter['Y'] > 0)
        return { color: 'G', label: _('Apto aplicación'), disclaimer: _('Requiere ajustes del equipo') };
    //All are yellow
    return { color: 'R', label: 'No aplicar' };
};

const ApplicationRisk = ({ risk, current, showTitle, noMargin = false, className, center }) => {
    const suggestion = getSuggestion(risk);
    return (
        <div className={classNames(styles.root, !noMargin && styles.margin)}>
            {showTitle && <div className={styles.title}>{_('Aplicación de fitosanitarios')}</div>}
            <div className={styles.references}>
                {Object.entries(risk).map(([type, value]) => {
                    return (
                        <div key={type}>
                            <div>{getLabel(type)}</div>
                            <div className={classNames(styles.dot, styles[`status-${value}`])} />
                        </div>
                    );
                })}
            </div>
            {current && (
                <div
                    className={classNames(
                        styles.suggestion,
                        !noMargin ? styles.border : styles.borderBottom,
                        className
                    )}
                >
                    <div className={styles.center}>
                        <div className={styles.mosquito} />
                        <div className={styles.container}>
                            <div className={styles.label}>
                                <div className={classNames(styles.dot, styles[`status-${suggestion.color}`])} />
                                <div>{suggestion.label}</div>
                            </div>
                            {<div className={styles.disclaimer}>{suggestion.disclaimer}</div>}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

ApplicationRisk.propTypes = {
    risk: PropTypes.object.isRequired,
};

export default ApplicationRisk;
